import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { tokens } from "../../theme";
import { DataGrid } from '@mui/x-data-grid';
import Header from '../../components/Header';
import { Box, IconButton, Button } from "@mui/material";
import { Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import { Autocomplete, TextField } from '@mui/material';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';


function AddSaleForm() {
  const [products, setProducts] = useState([]);
  const [selectedProductId, setSelectedProductId] = useState('');
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [saleItems, setSaleItems] = useState([]);
  const [file, setFile] = useState(null);
  const [isImportModalOpen, setIsImportModalOpen] = useState(false);
  const [isPaymentModalOpen, setIsPaymentModalOpen] = useState(false);
  const [paidAmount, setPaidAmount] = useState(0);
  const [dueDate, setDueDate] = useState("");
  const [customers, setCustomers] = useState([]);
  // Default to today (YYYY-MM-DD format)
    const [salesDate ] = useState(new Date().toISOString().split("T")[0]);
  // Load all products
  useEffect(() => {
    axios.get('https://store.petplanet.rw/api/products')
      .then(res => setProducts(res.data))
      .catch(err => console.error('Error fetching products:', err));
  }, []);
  
  useEffect(() => {
    axios.get('https://store.petplanet.rw/api/customers')
      .then(res => setCustomers(res.data))
      .catch(err => console.error("Error fetching customers:", err));
  }, []);
  // Set selected product based on dropdown
  useEffect(() => {
    const found = products.find(p => String(p.id) === selectedProductId);
    setSelectedProduct(found || null);
  }, [selectedProductId, products]);
  const totalSaleAmount = saleItems.reduce(
    (sum, item) => sum + Number(item.total),
    0
  );
  
  const balance = totalSaleAmount - paidAmount;

  const handleAddToTable = () => {
    if (!selectedProduct) return;
    
    if (selectedProduct.quantity <= 0) {
      alert("This product is out of stock.");
      return;
    }
  
    const exists = saleItems.find(item => item.product_id
       === selectedProduct.id);
    if (exists) {
      alert("Product already added!");
      return;
    }
  
    const newItem = {
      id: selectedProduct.id,
      product_id: selectedProduct.id,
      customer_id: "",
      name: selectedProduct.name,
      selling_price: parseFloat(selectedProduct.selling_price), // ✅ FIX
      quantity: 1,
      total: parseFloat(selectedProduct.selling_price),
      sales_date: salesDate
    };
  
    setSaleItems(prev => [...prev, newItem]);
    setSelectedProduct(null);
  };
  const handleQuantityChange = (id, quantity) => {
    setSaleItems(prev =>
      prev.map(item =>
        item.id === id
          ? {
              ...item,
              quantity,
              total: item.selling_price * quantity
            }
          : item
      )
    );
  };
  const handleDateChange = (id, value) => {
    setSaleItems(prev =>
      prev.map(item =>
        item.id === id ? { ...item, sales_date: value } : item
      )
    );
  };
   
  const handleSellingPriceChange = (id, newPrice) => {
    setSaleItems(prev =>
      prev.map(item =>
        item.id === id
          ? {
              ...item,
              selling_price: newPrice,
              total: newPrice * item.quantity // ✅ recalc total
            }
          : item
      )
    );
  };
    
  const handleRemove = (id) => {
    setSaleItems(prev => prev.filter(item => item.id !== id));
  };
  
  const uploadExcel = async () => {
    if (!file) {
      alert("Please upload a file");
      return;
    }
  
    const formData = new FormData();
    formData.append("file", file);
  
    try {
      const res = await fetch("https://store.petplanet.rw/api/sales/upload-excel", {
        method: "POST",
        body: formData,
      });
  
      const data = await res.json();
      console.log(data);
      alert("Upload successful");
    } catch (error) {
      console.error(error);
      alert("Upload failed");
    }
  };
  
  const handleSubmitAll = async () => {
  if (saleItems.length === 0) {
    return alert("No products added.");
  }

  try {
    for (const item of saleItems) {
      const payload = {
        product_id: Number(item.product_id),

        // ✅ FIX: use selected OR row OR fallback to 4
        customer_id: Number(
          selectedCustomer?.id || item.customer_id || 4
        ),

        quantity: Number(item.quantity),
        selling_price: Number(item.selling_price),
        total: Number(item.total),
        sales_date: item.sales_date,
        paid_amount: Number(paidAmount),
        due_date: balance > 0 ? dueDate : null
      };

      console.log("Submitting sale:", payload);

      // ✅ Extra protection (debugging)
      if (!payload.customer_id) {
        alert("Customer is missing!");
        return;
      }

      await axios.post('https://store.petplanet.rw/api/sales', payload, {
        headers: { 'Content-Type': 'application/json' }
      });
    }

    alert("All sales submitted successfully!");
    setSaleItems([]);

  } catch (err) {
    console.error("Sales submission error:", err.response?.data || err);
    alert("Failed to submit one or more Sales.");
  }
};
  const handleCustomerChange = (id, value) => {
    setSaleItems(prev =>
      prev.map(item =>
        item.id === id ? { ...item, customer_id: value } : item
      )
    );
  };
  
  
  
  const columns = [
    { field: 'name', headerName: 'Product Name', flex: 1, cellClassName: "name-column--cell",},
    {
      field: 'selling_price',
      headerName: 'Selling Price',
      flex: 1,
      renderCell: (params) => (
        <input
          type="number"
          min="0"
          value={params.row.selling_price}
          onChange={(e) => handleSellingPriceChange(params.row.id, parseFloat(e.target.value))}
          style={{ width: '80px' }}
        />
      )
    },
    {
      field: 'quantity',
      headerName: 'Quantity',
      flex: 1,
      renderCell: (params) => (
        <input
          type="number"
          min="1"
          value={params.row.quantity}
          onChange={(e) => handleQuantityChange(params.row.id, parseInt(e.target.value))}
          style={{ width: '60px' }}
        />
      )
    },
    {
      field: "customer_id",
      headerName: "Customer",
      flex: 1,
      renderCell: (params) => (
        <select
          value={params.row.customer_id || ""}
          onChange={(e) =>
            handleCustomerChange(params.row.id, Number(e.target.value))
          }
          style={{ width: "120px" }}
        >
          <option value="">Select Customer</option>
          {customers.map((cust) => (
            <option key={cust.id} value={cust.id}>
              {cust.name}
            </option>
          ))}
        </select>
      )
    },
    { field: 'total', headerName: 'Total', flex: 1 },
    {
      field: 'sales_date',          // ✅ match backend
      headerName: 'Sales Date',
      flex: 1,
      renderCell: (params) => (
        <input
          type="date"
          value={params.row.sales_date || new Date().toISOString().split("T")[0]}
          onChange={(e) => handleDateChange(params.row.id, e.target.value)}
          style={{ width: '130px' }}
        />
      )
    },
    {
      field: 'actions',
      headerName: 'Actions',
      renderCell: (params) => (
        <IconButton
          onClick={() => handleRemove(params.row.id)}
          style={{
            background: "none",
            border: "none",
            cursor: "pointer",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "15px"
          }}
        >
          <DeleteOutlinedIcon style={{ color: "red" }} />
        </IconButton>
      )
    }
  ];
  
  
  
  return (
    <>
    <Box m="20px" mt="80px">
    <Box display="flex" justifyContent="space-between" alignItems="center">
      <Header title="Add Sale" subtitle="Search for the products" />
      <IconButton
        onClick={() => setIsImportModalOpen(true)}
        sx={{
          fontSize: "13px",
          backgroundColor: tokens.redAccent[400],
          color: tokens.grey[100],
          padding: "14px",
          borderRadius: "15px",
          display: "flex",
          alignItems: "center",
          gap: "5px",
          marginTop: "-13px",
          "&:hover": {
            outline: `2px solid ${tokens.redAccent[400]}`,
            backgroundColor: tokens.redAccent[200],
          },
        }}
      >
        Import File <AddOutlinedIcon fontSize="15px" />
      </IconButton>
    </Box>
  
    {/* Autocomplete + Add Button */}
    <Box display="flex" alignItems="center" width="500px" gap={2} mt={2}>
      <Autocomplete
        style={{ flex: 1}}
        options={products}
        getOptionLabel={(option) => option.name}
        value={selectedProduct}
        onChange={(event, newValue) => setSelectedProduct(newValue)}
        popupIcon={null}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder="Select Product"
            variant="standard"
            InputProps={{
              ...params.InputProps,
              startAdornment: (
                <>
                  <SearchOutlinedIcon style={{ color: tokens.blueAccent[300], marginRight: '8px' }} />
                  {params.InputProps.startAdornment}
                </>
              ),
              disableUnderline: false, // to show the bottom border
              style: {
                borderBottom: '1px solid #004F92',
                paddingLeft: "10px",
                display: 'flex',
                alignItems: 'center',
                '&:hover': {
                  borderColor: "#004F92", // or whatever hover color you want
                },
              },
              
            }}
          />
        )}
      />
      {selectedProduct && (
          <Box mt={1} color={tokens.redAccent[500]} >
            <p>Available in stock: <strong>{selectedProduct.quantity}</strong></p>
          </Box>
        )}
        <IconButton
            onClick={handleAddToTable}
            sx={{
              fontSize: "13px",
              backgroundColor: tokens.redAccent[400],
              border: "none",
              color: tokens.grey[100],
              padding: "14px",
              borderRadius: "15px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "5px",
              marginTop: "-13px",
              transition: "all 0.3s ease",
              "&:hover": {
                outline: `2px solid ${tokens.redAccent[400]}`,
                outlineOffset: "1px",
                backgroundColor: tokens.redAccent[200],
              },
              "&:active": {
                outline: `2px solid ${tokens.redAccent[400]}`,
                transform: "scale(0.97)",
              },
            }}
          >
            Add to Table <AddOutlinedIcon fontSize="15px" />
        </IconButton>
    </Box>
  
      {/* Wrapper for the whole section */}
      <Box>
      
        {/* Submit Button aligned to the left */}
        <Box mb={2} display="flex" justifyContent="flex-end">
          <IconButton
            onClick={() => setIsPaymentModalOpen(true)}
            disabled={saleItems.length === 0}
            style={{
              fontSize: "13px",
              backgroundColor: tokens.redAccent[300],
              border: "none",
              color: tokens.grey[100],
              padding: "12px 18px",
              borderRadius: "15px",
              display: "flex",
              alignItems: "center",
              gap: "6px",
              cursor: saleItems.length === 0 ? "not-allowed" : "pointer",
              opacity: saleItems.length === 0 ? 0.6 : 1,
              "&:hover": {
                outline: `2px solid ${tokens.redAccent[400]}`,
                outlineOffset: "1px",
                backgroundColor: tokens.redAccent[200],
              },
              "&:active": {
                outline: `2px solid ${tokens.redAccent[500]}`,
                transform: "scale(0.97)",
              },
            }}
          >
            Submit All Sales <AddOutlinedIcon fontSize="small" />
          </IconButton>
        </Box>
      
        {/* Product Table */}
        <Box 
            height="400px"
            
            sx={{
                "& .MuiDataGrid-root": {
            border: "none",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .name-column--cell": {
            color: tokens.grey[800],
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: tokens.grey[100],
          },
          "& .MuiCheckbox-root": {
            border: "none",
            color: `${tokens.redAccent[400]} !important`,
          },
          "& .MuiDataGrid-columnHeader.action-column--header": {
            background: "none",
          },
          "& .MuiDataGrid-columnHeaderTitle": {
            color: `${tokens.grey[900]} !important`,
            fontSize: "12px",
          },
          "& .MuiDataGrid-columnSeparator--resizable": {
            color: `${tokens.blueAccent[100]} !important`,
          }
            }}
        >
          <DataGrid
            checkboxSelection rows={saleItems}
            columns={columns}
            pageSize={5}
            rowsPerPageOptions={[5]}
          />
        </Box>
      
      </Box>

  </Box>
  
  <Dialog
      sx={{
        "& .MuiDialog-paper": {
          width: "500px",
          position: "absolute",
          top: "0",
          left: "60%",
          transform: "translateX(-50%)",
        },
      }}
      open={isImportModalOpen}
      onClose={() => setIsImportModalOpen(false)}
    >
      <DialogTitle
        style={{
          background: tokens.redAccent[100],
          color: tokens.blueAccent[300],
          fontSize: "17px",
        }}
      >
        Import File
      </DialogTitle>
    
      <DialogContent style={{ background: tokens.grey[100], padding: "20px 30px" }}>
        <input
          type="file"
          accept=".xlsx,.xls"
          onChange={(e) => setFile(e.target.files[0])}
          style={{ marginTop: "10px" }}
        />
      </DialogContent>
    
      <DialogActions style={{ background: tokens.redAccent[100] }}>
        <Button
          style={{ color: tokens.blueAccent[300] }}
          onClick={() => setIsImportModalOpen(false)}
        >
          Cancel
        </Button>
    
        <Button
          style={{ color: tokens.blueAccent[300] }}
          onClick={uploadExcel}
        >
          Upload
        </Button>
      </DialogActions>
    </Dialog>
    {/* Payment Modal */}
      <Dialog open={isPaymentModalOpen} onClose={() => setIsPaymentModalOpen(false)}>
        <DialogTitle fontSize="20px" backgroundColor={tokens.redAccent[200]} color={tokens.blueAccent[400]}>
          Sale Payment
        </DialogTitle>
      
        <DialogContent>
      
          <Box mt="20px" mb={2}>
            <strong>Total Amount: {totalSaleAmount.toFixed(2)}</strong>
          </Box>
          <Box display="flex" justifyContent="space-between" alignItems="center" gap="10px">
            <TextField
              label="Amount Paid"
              type="number"
              fullWidth
              value={paidAmount}
              onChange={(e) => setPaidAmount(Number(e.target.value))}
              sx={{ mb: 2 }}
            />
        
            <TextField
              label="Balance"
              fullWidth
              value={balance.toFixed(2)}
              disabled
              sx={{ mb: 2 }}
            />
          </Box>
          {balance > 0 && (
            <TextField
              label="Due Date"
              type="date"
              fullWidth
              InputLabelProps={{ shrink: true }}
              value={dueDate}
              onChange={(e) => setDueDate(e.target.value)}
            />
          )}
      
        </DialogContent>
      
        <DialogActions style={{ background: tokens.redAccent[200] }} >
          <Button onClick={() => setIsPaymentModalOpen(false)} style={{ color: tokens.blueAccent[400] }}>
            Cancel
          </Button>
      
          <Button onClick={handleSubmitAll} style={{ color: tokens.blueAccent[400] }}>
            Confirm Sale
          </Button>
        </DialogActions>
      </Dialog>

  </>
    
  );
}

export default AddSaleForm;
